import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { AiSpendMonitorClient, aiSpendMonitorApiRef } from './api';
import { rootRouteRef } from './routes';

const aiSpendMonitorApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: aiSpendMonitorApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new AiSpendMonitorClient({ discoveryApi, fetchApi }),
    }),
});

const aiSpendReportPage = PageBlueprint.make({
  params: {
    path: '/ai-spend/reporting',
    title: 'AI spend reporting',
    routeRef: rootRouteRef,
    // The page renders its own BUI <FullPage>/<Header>.
    noHeader: true,
    loader: () =>
      import('./components/AiSpendReportPage').then(m => (
        <m.AiSpendReportPage />
      )),
  },
});

export const aiSpendMonitorPlugin = createFrontendPlugin({
  pluginId: 'ai-spend-monitor',
  title: 'AI spend monitor',
  routes: {
    root: rootRouteRef,
  },
  extensions: [aiSpendMonitorApi, aiSpendReportPage],
});

export default aiSpendMonitorPlugin;
